import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-658cf7b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row items-center" }, null, -1))
const _hoisted_2 = { class: "row no-wrap items-center" }
const _hoisted_3 = { class: "row items-center" }
const _hoisted_4 = { class: "row items-center no-wrap" }
const _hoisted_5 = { class: "text-primary-darker bg-warning-light q-py-sm rounded-borders" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_ctx.emailToImport)
    ? (_openBlock(), _createBlock(_component_q_expansion_item, _mergeProps({
        key: 0,
        "default-opened": _ctx.defaultOpened
      }, _ctx.EXPAND_ITEM_PROPS), {
        header: _withCtx(() => [
          _createVNode(_component_q_item_section, { "no-wrap": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, _mergeProps(_ctx.TEXT_TERTIARY_TITLE, { lines: 1 }), {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.emailLabel), 1)
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, { side: "" }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_q_btn, _normalizeProps(_guardReactiveProps(_ctx.BTN_NEGATIVE_SECONDARY_SM)), {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: _ctx.ICONS_NAME.FLAG_SOLID
                  }, null, 8, ["name"]),
                  _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('IMPORTANT')), 1)
                    ]),
                    _: 1
                  }, 16)
                ]),
                _: 1
              }, 16), [
                [_vShow, _ctx.isImportant]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_q_card, { class: "rounded-borders-important" }, {
            default: _withCtx(() => [
              (_ctx.parsedAttachments.length)
                ? (_openBlock(), _createBlock(_component_q_card_section, {
                    key: 0,
                    class: "q-pt-none q-pb-md"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item, {
                        class: "q-pa-none q-my-sm",
                        dense: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { side: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('ATTACHS_TO_UPLOAD')), 1)
                                ]),
                                _: 1
                              }, 16)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_2, [
                                (!_ctx.allAttachmentsSelected)
                                  ? (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
                                      key: 0,
                                      label: _ctx.t('ALL_ATTACHS'),
                                      onClick: _ctx.selectAllAttachments,
                                      class: "q-mr-sm custom-btn"
                                    }, _ctx.BTN_SECONDARY_SM), null, 16, ["label", "onClick"]))
                                  : _createCommentVNode("", true),
                                (_ctx.attachmentsIdsToImport.length)
                                  ? (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
                                      key: 1,
                                      label: _ctx.t('NONE_ATTACHS'),
                                      onClick: _ctx.unselectAllAttachments
                                    }, _ctx.BTN_SECONDARY_SM, {
                                      class: "custom-btn",
                                      unelevated: ""
                                    }), null, 16, ["label", "onClick"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailToImport.attachmentsParsed, (a, index) => {
                          return (_openBlock(), _createBlock(_component_q_checkbox, _mergeProps({
                            key: index,
                            val: a.dobjId,
                            "onUpdate:modelValue": _ctx.updateAttachmentsIdsToImport,
                            color: "primary"
                          }, _ctx.CHECKBOX_PROPS, {
                            modelValue: _ctx.attachmentsIdsToImport,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.attachmentsIdsToImport) = $event)),
                            style: 'margin-top: 0!important;'
                          }), {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_q_icon, _mergeProps({
                                  name: _ctx.ICONS_NAME.FILE_OUTLINE
                                }, _ctx.ICON_PROPS.BTN_SM), null, 16, ["name"]),
                                _createElementVNode("div", _mergeProps(_ctx.TEXT_CONTENT_BODY, { class: "ellipsis custom-area-width" }), [
                                  _createTextVNode(_toDisplayString(a.label) + " ", 1),
                                  _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(a.label), 1)
                                    ]),
                                    _: 2
                                  }, 1040)
                                ], 16)
                              ])
                            ]),
                            _: 2
                          }, 1040, ["val", "onUpdate:modelValue", "modelValue"]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_q_card_section, { class: "q-pa-md rounded-borders" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, _mergeProps(_ctx.TEXT_FORM_FIELD_LABEL, { class: "q-px-sm q-pb-sm" }), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('EMAIL_NOTE_LABEL')), 1)
                    ]),
                    _: 1
                  }, 16),
                  _createVNode(_component_q_input, _mergeProps(_ctx.INPUT_LG, {
                    modelValue: _ctx.description,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.description) = $event)),
                      _ctx.updateDescription
                    ],
                    style: 'max-width: 100%!important;',
                    rules: [(val) => val?.trim().length <= _ctx.MAX_LENGTH.EMAIL.NOTE],
                    class: "q-px-sm",
                    placeholder: _ctx.t('EMAIL_NOTE_PLACEHOLDER').toString(),
                    disable: !_ctx.canEditObject(_ctx.emailToImport)
                  }), {
                    append: _withCtx(() => [
                      (_ctx.description !== '')
                        ? (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.description = ''))
                          }, _ctx.BTN_TERTIARY_SM), {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                name: _ctx.ICONS_NAME.TIMES_CIRCLE_SOLID
                              }, null, 8, ["name"])
                            ]),
                            _: 1
                          }, 16))
                        : _createCommentVNode("", true)
                    ]),
                    error: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: _ctx.ICONS_NAME.WARNING_SOLID
                      }, null, 8, ["name"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.t('EMAIL_NOTE_LONG', { x: _ctx.MAX_LENGTH.EMAIL.NOTE })), 1)
                    ]),
                    _: 1
                  }, 16, ["modelValue", "onUpdate:modelValue", "rules", "placeholder", "disable"]),
                  (_ctx.canEditObject(_ctx.emailToImport))
                    ? (_openBlock(), _createBlock(_component_q_checkbox, _mergeProps({
                        key: 0,
                        class: "q-ml-none q-mt-md",
                        "onUpdate:modelValue": _ctx.importantToggle
                      }, _ctx.CHECKBOX_PROPS, {
                        modelValue: _ctx.isImportant,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isImportant) = $event))
                      }), {
                        default: _withCtx(() => [
                          _createElementVNode("span", _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), _toDisplayString(_ctx.t('MARK_AS_IMPORTANT')), 17)
                        ]),
                        _: 1
                      }, 16, ["onUpdate:modelValue", "modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.warnings.length)
                ? (_openBlock(), _createBlock(_component_q_card_section, {
                    key: 1,
                    class: "q-py-md q-px-md"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warnings, (message, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "q-px-md q-py-sm row items-center"
                          }, [
                            _createVNode(_component_q_item_section, {
                              avatar: "",
                              class: "q-pa-none"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_icon, {
                                  name: _ctx.ICONS_NAME.WARNING_SOLID,
                                  class: "text-warning"
                                }, null, 8, ["name"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_q_item_section, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(message), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 16, ["default-opened"]))
    : _createCommentVNode("", true)
}